import Typeahead from "./typeahead";
import typeaheadAutocompleteTemplates from "../templates/typeahead";
import Helpers from "./helpers";

declare var Mustache: any;
declare var $: any;

export default class AddressLookup {

	private container: HTMLDivElement;
	private lookupUpInput: HTMLInputElement;
	private address1: HTMLInputElement;
	private addressFields: NodeListOf<HTMLElement>;
	private lookupFields: NodeListOf<HTMLElement>;
	private form: HTMLFormElement;
	private manualEntryButton: HTMLButtonElement;
	private countryField: HTMLSelectElement;

	constructor() {

		this.container = document.querySelector('.js-address-lookup');

		if (!this.container) {
			return;
		}

		this.lookupUpInput = document.querySelector('.js-address-lookup-input');
		this.address1 = document.querySelector('input[data-name="address1"]');
		this.addressFields = document.querySelectorAll('.js-address-lookup-fields-container');
		this.lookupFields = document.querySelectorAll('.js-address-lookup-fields');
		this.manualEntryButton = document.querySelector('.js-address-lookup-enter-manually');
		this.form = this.container.closest('form');
		this.countryField = this.form.querySelector('select[data-name="addressCountry"]') ;

		if (!this.address1.value) {
			this.setupAutocomplete();
		} else {
			this.setupManualEntry();
		}

		if (this.manualEntryButton) {
			this.manualEntryButton.addEventListener('click', () => {
				this.setupManualEntry();
				Helpers.removeElement(this.manualEntryButton);
			});
		}

		this.watchCountryField();
		this.setPostcodeLabel();
		this.validation();
	}

	private watchCountryField() {

		this.countryField.addEventListener('change', (event: Event) => {
			this.setPostcodeLabel();
		});

	}

	private setPostcodeLabel() {
		const countryValue = parseInt(this.countryField.value);
		const postcodeLabel = this.form.querySelector('label[data-name="postcodeLabel"]') as HTMLInputElement;
		if (countryValue === 1) {
			postcodeLabel.innerHTML = `Postcode <span class="c-form__label-suffix"> (required)</span>`;
		} else {
			postcodeLabel.innerHTML = `Postcode <span class="c-form__label-suffix"> (optional)</span>`;
		}
	}

	private setupAutocomplete() {

		if (!this.lookupUpInput) {
			return;
		}

		this.hideElements(this.addressFields);
		this.showElements(this.lookupFields);

		new Typeahead(this.lookupUpInput, {
			charLimit: 3,
			onItemSelected: (item) => {
				this.addressSelect(item);
			},
			onInputChange: (term) => {
				if (!term) {
					this.lookupUpInput.setAttribute('data-last-id', '');
					this.lookupUpInput.setAttribute('data-typeahead-next', '');
					this.lookupUpInput.setAttribute('data-typeahead-id', '');
				}
			},
			requests: [
				{
					name: 'addresses',
					limit: 999,
					source: 'data-find-url',
					additionalQueryParameters: () => {
						const addressCountryElement = this.form.querySelector('select[data-name="addressCountry"]') as HTMLInputElement;
						const countryId = addressCountryElement.value;
						const lastId = this.lookupUpInput.getAttribute('data-last-id');
						return '&countryId=' + countryId + '&lastId=' + lastId;
					},
					templates: {
						suggestion: function (data) {
							const template = typeaheadAutocompleteTemplates.addressSuggestion;
							Mustache.parse(template);
							return Mustache.render(template, data);
						}
					}
				}
			]
		});

		this.lookupUpInput.setAttribute('autocomplete', 'none');
	}

	private setupManualEntry() {
		this.showElements(this.addressFields);
		this.hideElements(this.lookupFields);
	}

	private validation() {

		$(this.form).on('submit', () => {
			console.log('submit');
			/* TODO: jQuery validation plugin required for this check. Change when we change jQuery validate in a later ticket. */
			if (!$(this.form).valid()) {

				
				this.setupManualEntry();
				$(this.form).valid();
			}
		});

	}

	private addressSelect(input: HTMLElement) {

		const nextItem = input.getAttribute('data-typeahead-next');
		const addressId = input.getAttribute('data-typeahead-id');

		if (nextItem === 'Find') {
			/* We want the typeahead to show again to narrow down the address results */
			this.lookupUpInput.setAttribute('data-last-id', addressId);
			this.lookupUpInput.value = this.lookupUpInput.value + ' ';
			const event = document.createEvent('HTMLEvents');
			event.initEvent('input', true, false);
			this.lookupUpInput.dispatchEvent(event);
			this.lookupUpInput.focus();
		} else {

			fetch(this.lookupUpInput.getAttribute('data-retrieve-url') + "?id=" + addressId
			).then((response: any) => {
				if (response.ok) {
					return response.json();
				} else {
					throw new Error(response as any);
				}
			}).then((data) => {
				this.showElements(this.addressFields);
				this.hideElements(this.lookupFields);
				Helpers.removeElement(this.manualEntryButton);

				const companyAddressElement = this.form.querySelector('input[data-name="addressCompany"]') as HTMLInputElement;
				const address1Element = this.form.querySelector('input[data-name="address1"]') as HTMLInputElement;
				const address2Element = this.form.querySelector('input[data-name="address2"]') as HTMLInputElement;
				const address3Element = this.form.querySelector('input[data-name="address3"]') as HTMLInputElement;
				const addressTownElement = this.form.querySelector('input[data-name="addressTown"]') as HTMLInputElement;
				const postcodeElement = this.form.querySelector('input[data-name="addressPostcode"]') as HTMLInputElement;

				companyAddressElement.value = data.Company;
				address1Element.value = data.Address1;
				address2Element.value = data.Address2;
				addressTownElement.value = data.Town;
				postcodeElement.value = data.Postcode;

				if (data.Country !== null && data.Country !== undefined) {
					const countryElement = this.form.querySelector('select[data-name="addressCountry"]') as HTMLInputElement;
					if (data.Country.Enabled) {
						countryElement.value = data.Country.Id;
					}			
				}

			}).catch(() => {
				this.setupManualEntry();
			});

		}

	}

	private hideElements(elements) {
		for (let i = 0, len = elements.length; i < len; i++) {
			elements[i].style.display = 'none';
		}
	}

	private showElements(elements) {
		for (let i = 0, len = elements.length; i < len; i++) {
			elements[i].style.display = 'block';
		}
	}

}
